"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchSort = void 0;
var linkClick_1 = require("./linkClick");
var searchSort = function (event) {
    var _a;
    var mainEventData = {
        event: 'search-sort',
        eventInfo: 'search-sort',
        search: {
            searchSort: event.eventData.searchSort.searchSort,
        },
    };
    var linkEventData = (0, linkClick_1.linkClick)(event.eventData.searchSort.searchSort, ((_a = event.eventData.linkClick) === null || _a === void 0 ? void 0 : _a.linkModule) || 'coveo-sort-section', '');
    return [mainEventData, linkEventData];
};
exports.searchSort = searchSort;
